import Vue from 'vue'
import Vuex from 'vuex'
import {globalConf} from './config.global'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData: {
      impersona: {
        stato: false,
        denominazione: ''
      },
      stato: {
        installatore: false,
        consulente: false,
        azienda: false,
        admin: false
      }
    }
  },
  getters: {
    userData: state => {
      return state.userData
    },
    stato: state => {
      return state.userData.stato
    }
  },
  mutations: {
    impersona: (state, value) => {
      state.userData.impersona.stato = value.stato
      state.userData.impersona.denominazione = value.denominazione
    },
    setStatoInstallatore: (state, stato) => {
      state.userData.stato.installatore = stato
    },
    setStatoConsulente: (state, stato) => {
      state.userData.stato.consulente = stato
    },
    setStatoAzienda: (state, stato) => {
      state.userData.stato.azienda = stato
    },
    setStatoAdmin: (state, stato) => {
      state.userData.stato.admin = stato
    }
  },
  actions: {
    updateUserStatus: context => {
        //return Vue.http.post(globalConf.hostlink+'user/islogged', {}, {credentials : true}).then(response => {
        return Vue.http.post('user/islogged', {}, {credentials : true}).then(response => {
          if(response.body.success){
          context.commit('setStatoInstallatore', response.body.stato.installatore)
          context.commit('setStatoConsulente', response.body.stato.consulente)
          context.commit('setStatoAzienda', response.body.stato.azienda)
          context.commit('setStatoAdmin', response.body.stato.admin)
        }
        return
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore di comunicazione con il server!',
          type: 'error'
      })
      })
    }
  }
})
